import React from "react";
import LoanApplication from "../../../models/loan/loanApplication";
import Table from "react-bootstrap/esm/Table";
import "./ApplicantSection.css";
import Applicant from "../../../models/applicantForm/applicant";
import loanApplicationUtility from "utilities/LoanApplicationUtility";
import { isValid } from "date-fns";

interface ApplicantSectionProps {
  loanDetails: LoanApplication
}

export default class ApplicantSection extends React.Component<ApplicantSectionProps> {
  render() {
    return (
      <>
        <div>
          <h3>Primary Applicant</h3>
          {this.props.loanDetails.applicant != undefined && Object.keys(this.props.loanDetails.applicant).length > 0 &&
            <Table key={`applicant`} bordered striped={false} size="sm">
              <tbody>
                <tr>
                  <td width="250px" className="app-info"><strong>Applicant Name</strong></td>
                  <td className="app-info">{loanApplicationUtility.GetApplicantName(this.props.loanDetails.applicant)}</td>
                </tr>
                <tr>
                  <td width="250px" className="app-info"><strong>Applicant Address</strong></td>
                  <td className="app-info">{`${this.props.loanDetails.applicant.address}${this.props.loanDetails.applicant.addressLine2?.length > 0 ? `, ${this.props.loanDetails.applicant.addressLine2}` : ''}, ${this.props.loanDetails.applicant.city}, ${this.props.loanDetails.applicant.state} ${this.props.loanDetails.applicant.zipCode}`}</td>
                </tr>
                <tr>
                  <td width="250px" className="app-info"><strong>ID Verified</strong></td>
                  <td className="app-info">{this.props.loanDetails.applicant.identityVerified ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                  <td width="250px" className="app-info"><strong>Date Of Birth</strong></td>
                  <td className="app-info">{isValid(this.props.loanDetails.applicant.dateOfBirth) ? loanApplicationUtility.GetFullYearDateText(this.props.loanDetails.applicant.dateOfBirth) : new Date(this.props.loanDetails.applicant.dateOfBirth).toLocaleDateString()}</td>
                </tr>
                <tr>
                  <td width="250px" className="app-info"><strong>SSN</strong></td>
                  <td className="app-info">{this.props.loanDetails.applicant.ssn}</td>
                </tr>
              </tbody>
            </Table>
          }

          {this.props.loanDetails.jointApplicant != undefined && Object.keys(this.props.loanDetails.jointApplicant).length > 0 &&
            <>
              <h3>Joint Applicant</h3>
              <Table key={`joint-applicant`} bordered striped={false} size="sm">
                <tbody>
                  <tr>
                    <td width="250px" className="app-info"><strong>Joint Applicant Name</strong></td>
                    <td className="app-info">{loanApplicationUtility.GetApplicantName(this.props.loanDetails.jointApplicant)}</td>
                  </tr>
                  <tr>
                    <td width="250px" className="app-info"><strong>Joint Applicant Email</strong></td>
                    <td className="app-info">{this.props.loanDetails.jointApplicant.emailAddress}</td>
                  </tr>
                  <tr>
                    <td width="250px" className="app-info"><strong>Joint Applicant Phone</strong></td>
                    <td className="app-info">{`${loanApplicationUtility.FormatPhoneNumber(this.props.loanDetails.jointApplicant.phoneNumber ?? '')}`}</td>
                  </tr>
                  <tr>
                    <td width="250px" className="app-info"><strong>Joint Applicant Address</strong></td>
                    <td className="app-info">{`${this.props.loanDetails.jointApplicant.address}${this.props.loanDetails.jointApplicant.addressLine2?.length > 0 ? `, ${this.props.loanDetails.jointApplicant.addressLine2}` : ''}, ${this.props.loanDetails.jointApplicant.city}, ${this.props.loanDetails.jointApplicant.state} ${this.props.loanDetails.jointApplicant.zipCode}`}</td>
                  </tr>
                  {/* <tr>
                  <td width="250px" className="app-info"><strong>ID Verified</strong></td>
                  <td className="app-info">{this.props.loanDetails.applicant.identityVerified ? 'Yes' : 'No'}</td>
                </tr> */}
                  <tr>
                    <td width="250px" className="app-info"><strong>Joint Applicant Date Of Birth</strong></td>
                    <td className="app-info">{isValid(this.props.loanDetails.jointApplicant.dateOfBirth) ? loanApplicationUtility.GetFullYearDateText(this.props.loanDetails.jointApplicant.dateOfBirth) : new Date(this.props.loanDetails.jointApplicant.dateOfBirth).toLocaleDateString()}</td>
                  </tr>
                  <tr>
                    <td width="250px" className="app-info"><strong>Joint Applicant SSN</strong></td>
                    <td className="app-info">{this.props.loanDetails.jointApplicant.ssn}</td>
                  </tr>
                </tbody>
              </Table>
            </>
          }
        </div>
      </>
    );
  }
}